import React from "react";
import styles from "./ShipmentDetailsStyles";
import ShipmentBadgeList from "../common/ShipmentBadgeList";
import clsx from "clsx";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  withStyles,
  IconButton,
  Collapse,
} from "@material-ui/core";
import ShipmentDetailsHeader from "./ShipmentDetailsHeader";
import { observer, inject } from "mobx-react";
import appConstants from "../../../../../../appConstants";
import FreightDescription from "./FreightDescription";
import { compose } from "recompose";
import { withFeatureFlags } from "../../../../../../userProfile/featureFlagsContext";

@inject("DispatchStore")
@observer
class ShipmentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.formComponent = React.createRef();
    this.state = {
      expanded: false,
    };
    this.enableCheckDigit = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.CheckDigitRequired
    );
  }

  handleExpandMoreClick = () => {
    this.setState({ expanded: true });
  };
  handleExpandLessClick = () => {
    this.setState({ expanded: false });
  };
  render() {
    const { classes, shipmentData, freightBillDetails } = this.props;
    return (
      <React.Fragment>
        <ShipmentDetailsHeader
          handleExpandMoreClick={this.handleExpandMoreClick}
          expanded={this.state.expanded}
          proId={
            this.enableCheckDigit
              ? shipmentData.checkDigitPro
              : shipmentData.proId
          }
          deliveryStatus={this.props.DispatchStore.getDeliveryStatusLabelFromCode(
            shipmentData.deliveryCode
          )}
        />
        <ShipmentBadgeList
          stopType={appConstants.STOP_TYPE.Delivery}
          stc={shipmentData.stc}
          pieces={shipmentData.pieces}
          hu={shipmentData.hu}
          weight={shipmentData.weight}
        />
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <div className={classes.collapsibleContainer}>
            <p className={classes.shipperDetails}>SHIPPER DETAILS</p>
            <p className={classes.shipperName}>{shipmentData.shipperName}</p>
            <p className={classes.shipperAddress}>
              {shipmentData.shipperAddress}
            </p>
            <div id="proDetailsContent">
              <div className={classes.proDetailsContent}>
                <span className={classes.proDetailsLabel}>Shipper #</span>
                <span className={classes.proDetailsValue}>
                  {shipmentData.shipperNumber}
                </span>
              </div>
              <div className={classes.proDetailsContent}>
                <span className={classes.proDetailsLabel}>BL #</span>
                <span className={classes.proDetailsValue}>
                  {shipmentData.bolNumber}
                </span>
              </div>
              <div className={classes.proDetailsContent}>
                <span className={classes.proDetailsLabel}>PO #</span>
                <span className={classes.proDetailsValue}>
                  {shipmentData.poNumber}
                </span>
              </div>
              <div className={classes.proDetailsContent}>
                <span className={classes.proDetailsLabel}>
                  Origin - Destination
                </span>
                <span className={classes.proDetailsValue}>
                  {shipmentData.origin && shipmentData.destination
                    ? `${shipmentData.origin} - ${shipmentData.destination}`
                    : ""}
                </span>
              </div>
              <div className={classes.proDetailsContent}>
                <span className={classes.proDetailsLabel}>Pick-up Date</span>
                <span className={classes.proDetailsValue}>
                  {shipmentData.pickupDate}
                </span>
              </div>
              <div className={classes.proDetailsContent}>
                <span className={classes.proDetailsLabel}>Terms #</span>
                <span className={classes.proDetailsValue}>
                  {shipmentData.billingTerms}
                </span>
              </div>
            </div>
            <br />
            <FreightDescription 
              freightBillDetails={freightBillDetails} 
            />
          </div>
          <div className={classes.hideDetailsContainer}>
            <IconButton
              className={`${clsx(classes.expand, {
                [classes.expandOpen]: this.state.expanded,
              })} ${classes.hideDetailIcon}`}
              onClick={this.handleExpandLessClick}
              aria-expanded={this.state.expanded}
              aria-label="show more"
            >
              <span className={classes.hideDetailsLabel}>Hide Details</span>
              <ExpandLessIcon className={classes.hideDetailsLabel} />
            </IconButton>
          </div>
        </Collapse>
      </React.Fragment>
    );
  }
}

export default compose(withStyles(styles), withFeatureFlags)(ShipmentDetails);
